import gql from 'graphql-tag';

export const GET_ANTI_FRAUD_BY_PERSONAL_ID = gql`
	query getAntiFraudByPersonalId($personalId: Int, $yearLength: Int) {
		getAntiFraudByPersonalId(personalId: $personalId, yearLength: $yearLength) {
			id
			personalId
			incidentId
			vehicleIdentificationNumber
			vehicleRegistration
			vehicleClassification
			claimType
			manufacturer
			chassisNumber
			accidentDate
			requestDate
			createdAt
			updatedAt
		}
	}
`;

export const GET_ANTI_FRAUD_BY_REGISTRATION_PLATES_VIN_NUMBER = gql`
	query getAntiFraudByRegistrationPlatesVinNumber(
		$registrationPlatesVinNumber: String
	) {
		getAntiFraudByRegistrationPlatesVinNumber(
			registrationPlatesVinNumber: $registrationPlatesVinNumber
		) {
			id
			personalId
			incidentId
			vehicleIdentificationNumber
			vehicleRegistration
			vehicleClassification
			claimType
			manufacturer
			chassisNumber
			accidentDate
			requestDate
			createdAt
			updatedAt
		}
	}
`;

export const GET_ANTI_FRAUD_VALIDITY_ACCIDENT = gql`
	query getAntiFraudValidityAccident(
		$registrationPlates: String
		$vinNumber: String
	) {
		getAntiFraudValidityAccident(
			registrationPlates: $registrationPlates
			vinNumber: $vinNumber
		) {
			id
			personalId
			incidentId
			vehicleIdentificationNumber
			vehicleRegistration
			vehicleClassification
			claimType
			manufacturer
			chassisNumber
			accidentDate
			requestDate
			createdAt
			updatedAt
		}
	}
`;

export const GET_ANT_FRAUD_MULTIPLE_BY_PERSONAL_ID = gql`
	query getAntiFraudMultipleByPersonalId(
		$personalNumbers: [Int]
		$yearLength: Int
	) {
		getAntiFraudMultipleByPersonalId(
			personalNumbers: $personalNumbers
			yearLength: $yearLength
		) {
			id
			personalId
			incidentId
			vehicleIdentificationNumber
			vehicleRegistration
			vehicleClassification
			claimType
			manufacturer
			chassisNumber
			accidentDate
			requestDate
			createdAt
			updatedAt
		}
	}
`;
